import { Row, Col, Affix, LocaleProvider, Popover, Divider, message } from 'ant-design-vue'
import Cart from './Cart.vue'
import '@/components/l8-icon'
import moment from 'moment'

import './index.less'

/* istanbul ignore next */
Cart.install = function (Vue) {
  Vue.component(Cart.name, Cart)
  Vue.use(Popover)
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Affix)
  Vue.use(LocaleProvider)
  Vue.use(Divider)
  Vue.prototype.$message = message

  const passengerType = {
    'ADT': '成人',
    'CHD': '儿童',
    'INF': '婴儿',
    'MWD': '伤残军人',
    'PWD': '伤残人民警察'
  }

  const couponTypeMap = {
    TICKET: '机票',
    LUGGAGE: '行李',
    MEAL: '餐食',
    ITINERARY: '行程单',
    VIPHALL: '贵宾厅'
  }

  Vue.filter('ruleFee', (value, txt = '-') => {
    if (!value) {
      return txt
    }

    let val = value - 0

    if (isNaN(val)) {
      return value
    }

    if (val > 0) {
      return val + '元/人'
    }

    return txt
  })

  Vue.filter('passengers', (value) => {
    if (!value || !value.length) {
      return '-'
    }
    const list = []

    value.forEach(item => {
      if (item.count !== '0') {
        list.push(`${item.count}${passengerType[item.passengerType]}`)
      }
    })

    if (list.length) {
      return list.join(', ')
    } else {
      return '-'
    }
  })

  Vue.filter('stopTime', (value) => {
    if (!value) {
      return '-'
    }

    const day = Math.floor(value / (24 * 3600 * 1000))
    const hour = Math.floor(value / (3600 * 1000))
    const second = Math.ceil((value - hour * 3600 * 1000) / 60000)
    let txt = `${hour}小时${second}分钟`
    if (day) {
      txt = `${day}天${txt}`
    }

    return txt
  })

  Vue.filter('passengerType', (value) => {
    if (!value) {
      return '-'
    }

    return passengerType[value] || '-'
  })

  Vue.filter('product', (detail = {}, item = {}) => {
    const { offerItemType } = item

    if (!offerItemType) {
      return '-'
    }

    if (offerItemType?.toLocaleUpperCase()?.indexOf('LUGGAGE') >= 0) {
      return `预付费行李( ${detail.productName} )`
    }

    if (offerItemType === 'COUPON') {
      return couponTypeMap[detail.couponType] + detail.productName
    }

    return detail.productName
  })

  Vue.filter('format', (value, format = 'YYYY-MM-DD') => {
    if (!value) {
      return '-'
    }

    return moment(value).format(format)
  })

  Vue.filter('gtDay', (flight) => {
    if (!flight) {
      return
    }

    let start = new Date(flight.departureDate).getTime()
    let end = new Date(flight.arrivalDate).getTime()
    const gt = Math.floor((end - start) / (24 * 3600 * 1000))
    return gt ? `${gt > 0 ? '+' + gt : gt}天` : ''
  })

  // 机票优惠券金额大于机票价格时的处理
  Vue.filter('couponAmount', (item = {}) => {
    const [ticketTotalFare, cartTicketCouponItemAmount] = [item.passengerPrices?.[0]?.totalFare, item.deductible?.couponAmount]
    return Math.min(cartTicketCouponItemAmount, ticketTotalFare)
  })
}

export default Cart
